import { useLang } from '@/i18n';
import EcoSpace from 'eco-design/base/eco-space';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoVideo from 'eco-design/base/eco-video';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import styles from './index.module.scss';

export default function SectionA3() {
    const { t } = useLang('theProduct.SectionA3');

    return (
        <div className={`page-sectionA3 ${styles.SectionA3}`}>
            <EcoSpace />
            <EcoSectionCommon title={t('title')} desc={t('desc')} />
            <EcoSpaceSmall />
            <div className={`eco-content ${styles.SectionA3}`}>
                <div className="content">
                    <EcoVideo pc={'https://websiteoss.ecoflow.com/upload/video/1743161589856/light.mp4'} autoPlay={true} loop={true} />
                    <div className="activationWatt">
                        <div className="wattValue">{t('value')}</div>
                        <div className="wattLabel">{t('value_desc')}</div>
                    </div>
                </div>
            </div>
        </div>
    );
}
